/*
 * @Author: your name
 * @Date: 2021-03-16 19:39:04
 * @LastEditTime: 2021-03-16 19:55:47
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /sunyur/fe-mall/pages/index/src/router/frequent.js
 */
export default {
  fluid: [
    // 采购商城 - 常购商品
    {
      path: '/frequent',
      name: 'frequent',
      component: () => import(/* webpackChunkName: "portal" */'../routes/frequent/index.vue'),
      meta: {
        title: {
          'zh-CN': '常购商品',
          en: '常购商品_en',
          jp: '常购商品_jp'
        },
        spmB: 'b1'
      }
    }
  ]
}
